import React from 'react';

import './style.css';

const Paragraph = ({ children }) => {
  return (
      <p className="paragraph">{children}</p>
  );
};

export default Paragraph;
